module.exports = __webpack_public_path__ + "static/img/banner2-2.01f02fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2-2.jpg
// module id = kACC
// module chunks = 1